import mixpanel from 'mixpanel-browser'

const TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN
const API_HOST = import.meta.env.VITE_MIXPANEL_API_HOST

const ENABLED = !!TOKEN && import.meta.env.VITE_MIXPANEL_ENABLED !== 'false'

let initialized = false

export function initAnalytics() {
  if (initialized || !ENABLED) return
  mixpanel.init(TOKEN, {
    autocapture: true,
    track_pageview: false,
    record_sessions_percent: 0,
    batch_requests: false,
    api_host: API_HOST,
    debug: import.meta.env.DEV,
  })
  initialized = true
}

export function track(event, properties, options) {
  if (!initialized) return
  mixpanel.track(event, properties, options)
}

export function startSessionRecording() {
  if (!initialized) return
  mixpanel.start_session_recording()
}

export function stopSessionRecording() {
  if (!initialized) return
  mixpanel.stop_session_recording()
}
